var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapsible } from "@filadd/phi-plus-core";
import { useState } from "react";
import { MenuItem } from "./MenuItem";
import { sectionMenuItemRecipe } from "./recipes/sectionMenuItemRecipe";
export const SectionMenuItem = ({ section, displayText, hasScrollbar, }) => {
    var _a;
    const [open, setOpem] = useState(false);
    const styles = sectionMenuItemRecipe({ hasScrollbar });
    return (_jsxs(Collapsible.Root, { open: open, onOpenChange: () => setOpem(!open), className: styles.root, children: [_jsx(Collapsible.Trigger, { className: styles.trigger, children: _jsx(MenuItem, Object.assign({}, section, { isExpanded: open, displayText: displayText, isActive: section.childItemIsActive && !(open && displayText), hasChildren: true })) }), _jsx(Collapsible.Content, { className: styles.content, children: _jsx("div", { className: styles.itemsContent, children: (_a = section.items) === null || _a === void 0 ? void 0 : _a.map((_a) => {
                        var { isActive } = _a, feature = __rest(_a, ["isActive"]);
                        return (_createElement(MenuItem, Object.assign({}, feature, { key: feature.name, isActive: isActive && displayText, displayText: displayText, hasScrollbar: hasScrollbar, asChild: true })));
                    }) }) })] }));
};
//# sourceMappingURL=SectionMenuItem.js.map